import { InstagramAccountObject } from "store/entities/InstagramAccount/types";

const instagramAccount: InstagramAccountObject = {
	id: "17841409197628845",
	screen_name: "busigitest",
	name: "BusiTest",
	profile_picture_url: "https://scontent.xx.fbcdn.net/v/t51.2885-15/44498877_709560539427853_611013283163406336_n.jpg",
	facebook_page_id: "292403691614670",
	facebook_page_name: "BusiTest",
	mentions_subscribed: true
};

export default instagramAccount;
